import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { AddRoute, GetRoute, UpdateRoute, getRouteById } from "../../Apis/routeMasterApi";
import { GetZone, GetCirclebyID, GetCircle, GetWard, GetWardsbyCircleId } from "../../Apis/organizationApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { AllCollectionPointDetails, GetAllCollectionPointsZoneCircle, GetAllCollectionPointsZone, } from "../../Apis/collectionPointsApi";
import { useNavigate } from "react-router-dom";
import Loader from "../../Common/Loader/loader";
import { withTranslation } from "react-i18next";
import { AllShiftMaster } from "../../Apis/shiftMasterApi";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations
import ExcelJS from "exceljs";
const RouteMaster = ({ t }) => {
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm()
  const [isEditMode, setIsEditMode] = useState(false);
  const [lgShow, setLgShow] = useState(false);
  const headers = ["routeCode", "zone", "circle", "ward", "shift", "status", "actions"]
  const [routeData, setRouteData] = useState([]);
  const [editRouteData, setEditRouteData] = useState("");
  const [formInput, setFormInput] = useState({
    routeCode: "",
    zoneId: "",
    circleId: "",
    wardId: "",
    collectionPointId: "",
    sortOrder: "",
    shiftId: "",
    routeId: "",
    isActive: true,
  });
  const [allZones, setAllZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedCircles, setSelectedCircles] = useState([]);
  const [noCircles, setNoCircles] = useState(false);
  const [loadingCircles, setLoadingCircles] = useState(false);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [selectedRoute, setSelectedRoute] = useState(null)
  const [gvpPoints, setGvpPoints] = useState([{ id: 1, value: "", sortOrder: "" }]);
  const [shiftData, setShiftData] = useState([]);
  const resetRef = useRef(null);
  const [loadingWards, setLoadingWards] = useState(false);
  const [wards, setWards] = useState([]);
  const [circles, setCircles] = useState([]);
  const [selectedWard, setSelectedWard] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [collectionPointZone, setCollectionPointZone] = useState([]);
  const [collectionPointZoneWithCircle, setCollectionPointZoneWithCircle] = useState([]);
  const [filterOriginalRouteData, setFilterOriginalRouteData] = useState([]);

  const resetFields = (reset) => {
    setFormInput({
      routeCode: "",
      zoneId: "",
      circleId: "",
      wardId: "",
      collectionPointId: "",
      sortOrder: "",
      shiftId: "",
      routeId: "",
      isActive: "",
    });
    setGvpPoints([{ id: 1, value: "", sortOrder: "" }]);
    resetRef.current();
  }

  useEffect(() => {
    resetRef.current = reset;
  }, [reset]);

  const handleClose = () => {
    resetFields();
    setLgShow(false);
    setIsEditMode(false);
    setSelectedRoute(null);
    setFormSubmitted(false);
  }

  const fetchCollectionPointData = async () => {
    try {
      const response = await AllCollectionPointDetails();
      // setCollectionPointData(response);
      setCollectionPointZone(response)
    } catch (error) {
      console.log(error)
    }
  }

  const handleEditRoute = async (selectedRouteData) => {
    try {
      const response = await getRouteById(selectedRouteData.routeId); // Call getRouteById API
      const routeData = response.data; // Assuming response.data contains route details
      setEditRouteData(routeData);
      setIsEditMode(true);
      setLgShow(true);
      setIsOptionsLoading(true)

      const { circleId, zoneId, wardId, collectionPoints } = routeData;

      const gvpPoints = collectionPoints.map((point, index) => ({
        id: index + 1,
        // id: point.id,
        value: point.collectionPointId,
        sortOrder: point.sortOrder,
      }));
      setGvpPoints(gvpPoints);
      // console.log(gvpPoints, 'gvpPoints')

      setFormInput({
        ...formInput,
        zoneId,
        circleId,
        wardId,
        // route_name: routeData.route_name,
        shiftId: routeData.shiftId,
        routeCode: routeData.routeCode,
        // collectionPointId: routeData.collectionPoints,

        collectionPointId: routeData.collectionPointId,
        sortOrder: routeData.sortOrder,
        // collectionPointId: gvpPoints.map(point => point.value).join(','),

        // collectionPointId: gvpPoints.length > 0 ? gvpPoints[0].value : "",
        // sortOrder: gvpPoints.length > 0 ? gvpPoints[0].sortOrder : "",
        routeId: routeData.routeId,
        isActive: routeData.isActive,
      });

      // call collection point api with zone and circle id 
      // Call GetAllCollectionPointsZone API
      try {
        const zoneResponse = await GetAllCollectionPointsZone({ zoneId });
        setCollectionPointZone(zoneResponse.data);
      } catch (error) {
        console.error("Error fetching collection points zone:", error);
      }

      // Call GetAllCollectionPointsZoneCircle API
      try {
        const circleResponse = await GetAllCollectionPointsZoneCircle({ zoneId, circleId });
        setCollectionPointZoneWithCircle(circleResponse.data);
      } catch (error) {
        console.error("Error fetching collection points zone circle:", error);
      }


      // old
      try {
        const circlesData = await GetCirclebyID(zoneId);
        setCircles(circlesData);
      } catch (error) {
        console.error("Error fetching circles data:", error);
      }

      reset();
      setIsOptionsLoading(false)
      setLgShow(true);
      // AllCollectionPointDetails()
    } catch (error) {
      console.error('Error fetching route data:', error);
    }
  };

  const fetchRoute = async () => {
    try {
      const [routeResponse, wardNameResponse, zoneNameResponse, circleNameResponse, shiftNameResponse] = await Promise.all([
        GetRoute(),
        GetWard(),
        GetZone(),
        GetCircle(),
        AllShiftMaster(),
      ]);
      const routeAllData = routeResponse.data.map(station => {
        const ward = wardNameResponse.find(ward => ward.wardId === station.wardId);
        const zone = zoneNameResponse.find(zone => zone.zoneId === station.zoneId);
        const circle = circleNameResponse.find(circle => circle.circleId === station.circleId);
        const shift = shiftNameResponse.find(shift => shift.shiftId === station.shiftId);

        // console.log(wardNameResponse, 'wardNameResponse');
        // console.log(zoneNameResponse, 'zoneNameResponse');
        // console.log(circleNameResponse, 'circleNameResponse');
        // console.log(shiftNameResponse, 'shiftNameResponse');
        return {
          ...station,
          ward: ward ? ward.wardName : "",
          zone: zone ? zone.zoneName : "",
          circle: circle ? circle.circleName : "",
          shift: shift ? shift.shiftName : "",
          status: station.isActive ? "Active" : "InActive",
        };
      });

      // Sort the data based on the isActive field
      const sortedRouteData = routeAllData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });


      setRouteData(sortedRouteData);
      setFilterOriginalRouteData(sortedRouteData);


      // // zone true values for dropdown
      const zoneTrueValues = zoneNameResponse.filter(item => item.isActive === true)
      setAllZones(zoneTrueValues);
      // // console.log(zoneTrueValues, 'zoneTrueValues response of all TRUE')
      // // circle true values for dropdown
      const circleTrueValues = circleNameResponse.filter(item => item.isActive === true)
      setCircles(circleTrueValues);
      // // console.log(circleTrueValues, 'circleTrueValues response of all TRUE')
      // // ward true values for dropdown
      const wardTrueValues = wardNameResponse.filter(item => item.isActive === true)
      setWards(wardTrueValues);
      // // console.log(wardTrueValues, 'wardTrueValues response of all TRUE')
      // // shift true values for dropdown
      const shiftTrueValues = shiftNameResponse.filter(item => item.isActive === true)
      setShiftData(shiftTrueValues);
      // // console.log(shiftTrueValues, 'shiftTrueValues response of all TRUE')



      // setRouteData(routeAllData);
      // console.log(routeAllData, 'routeAllData'
      // const response = await GetRoute();
      // setRouteData(response.data);
      // console.log(routeAllData, 'responseRoute')
      setIsOptionsLoading(false)
    } catch (error) {
      console.error("Error fetching Route data:", error);
    }
  };

  const fetchShift = async () => {
    try {
      const response = await AllShiftMaster();
      setShiftData(response);
      // console.log(response.data, 'shift response')
    } catch (error) {
      console.log(error)
    }
  }


  const addNewRoute = async (data) => {
    setFormSubmitted(true);
    setIsOptionsLoading(true)

    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      // const zoneId = data.zoneId || ''
      // const circleId = data.circleId || ''
      // const wardId = data.wardId || ''
      // const shiftId = data.shiftId || ''
      // const routeCode = data.routeCode || ''
      // const routeId = data.routeId || ''
      // const collectionPoints = gvpPoints.map(point => ({
      //   collectionPointId: point.value,
      //   sortOrder: point.sortOrder
      // }));
      // const isActive = data.isActive || ''
      // Check if any collection point is selected
      if (gvpPoints.length === 0 || gvpPoints.some(point => !point.value || !point.sortOrder)) {
        // Display toast message indicating that at least one collection point should be selected
        toast.error("Please select at least one collection point", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
        return;
      }

      if (
        !formInput.zoneId
        || !formInput.circleId
        || !formInput.wardId
        || !formInput.shiftId
        || !formInput.routeCode
        // || !formInput.collectionPointId
        // || !formInput.sortOrder
        // || !formInput.isActive
      ) {
        // Display toast message indicating the required field
        // toast.error("Please fill out all required fields", {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        // });
        return;
      }
      // const isActive = isEditMode ? formInput.isActive : true;
      // new
      const { zoneId, circleId, wardId, shiftId, routeCode, routeId, isActive } = formInput;
      const collectionPoints = gvpPoints.map(point => ({
        collectionPointId: point.value,
        sortOrder: point.sortOrder
      }));
      const requestData = {
        zoneId,
        circleId,
        wardId,
        shiftId,
        routeCode,
        routeId,
        collectionPoints,
        isActive,
      }

      if (isEditMode) {
        const res = await UpdateRoute(isEditMode.id, requestData)
        // console.log(res, 'from update function')
        const successMessage = 'Route Updated Successfully!'
        toast.success(successMessage, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        fetchRoute();
        reset();
        handleClose();
      } else {
        const res = await AddRoute(requestData);
        // console.log(res, 'res from add')
        const successMessage = 'New Route Added Successfully!'
        toast.success(successMessage, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
        reset();
        fetchRoute();
        handleClose();
      }
    } catch (error) {
      // if (error.response && error.response.data && error.response.data.errors) {
      //   Object.values(error.response.data.errors).map((item) => {
      //     toast.error(item[0], {
      //       position: 'top-right',
      //       autoClose: 3000,
      //       hideProgressBar: false,
      //       closeOnClick: true,
      //       pauseOnHover: true,
      //       draggable: true,
      //       progress: undefined,
      //     });
      //   });
      // } else {
      //   toast.error("An error occurred", {
      //     position: 'top-right',
      //     autoClose: 3000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      //   });
      // }
      if (error.response) {
        // console.log(error.response, 'error.response')
        const { status, data } = error.response;
        if (status === 400) {
          const validationErrors = data;
          toast.error(validationErrors, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 409) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else {
          toast.error("An error occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      } else {
        toast.error("An error occurred. Please try again later.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
      }

    } finally {
      setIsOptionsLoading(false)
    }
  }

  const handleKeyDown = (event, callback) => {
    if (event.key === 'Enter' && event.shiftKey === false) {
      event.preventDefault()
      callback(addNewRoute)
    }
  }

  const handleShiftChange = async (shiftId) => {
    setFormInput((prevData) => ({
      ...prevData,
      shiftId: shiftId,
    }));
  };

  useEffect(() => {
    fetchRoute();
    fetchShift();
    fetchCollectionPointData();
  }, [])

  // const handleStatusChange = (e) => {
  //   const statusValue = e.target.id === "activeRadio" ? 1 : 2;
  //   setFormInput((prevData) => ({
  //     ...prevData,
  //     status: statusValue,
  //   }));
  // };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      // [name]: value === "true" ? true : false,
      [name]: value === "true",
    }));
  };

  // select option
  const addSelectOption = () => {
    const newGvpPoint = { id: gvpPoints.length + 1, value: "", sortOrder: "" };
    setGvpPoints((prevGvpPoints) => [...prevGvpPoints, newGvpPoint]);

  };

  const removeSelectOption = (id) => {
    setGvpPoints((prevGvpPoints) =>
      prevGvpPoints.filter((gvp) => gvp.id !== id));
    reset();
  };

  const handleSelectChange = (id, newValue) => {
    setGvpPoints((prevGvpPoints) =>
      prevGvpPoints.map((gvp) =>
        gvp.id === id ? { ...gvp, value: newValue } : gvp
      )
    );
    // Update formInput state with the new collectionPointId
    setFormInput((prevData) => ({
      ...prevData,
      collectionPointId: newValue
    }));
  };
  // const handleSelectChange = (id, newValue) => {
  //   const updatedGvpPoints = gvpPoints.map((gvp) =>
  //     gvp.id === id ? { ...gvp, value: newValue } : gvp
  //   );
  //   setGvpPoints(updatedGvpPoints);

  //   // Update formInput state with the new collectionPointId
  //   setFormInput((prevData) => ({
  //     ...prevData,
  //     collectionPointId: newValue
  //   }));
  // };

  const handleSortOrderChange = (id, newSortOrder) => {
    setGvpPoints((prevGvpPoints) =>
      prevGvpPoints.map((gvp) =>
        gvp.id === id ? { ...gvp, sortOrder: newSortOrder } : gvp
      )
    );
    // Update formInput state with the new sortOrder value
    setFormInput((prevData) => ({
      ...prevData,
      sortOrder: newSortOrder
    }));
  };
  // const handleSortOrderChange = (id, newSortOrder) => {
  //   const updatedGvpPoints = gvpPoints.map((gvp) =>
  //     gvp.id === id ? { ...gvp, sortOrder: newSortOrder } : gvp
  //   );
  //   setGvpPoints(updatedGvpPoints);

  //   // Update formInput state with the new sortOrder value
  //   setFormInput((prevData) => ({
  //     ...prevData,
  //     sortOrder: newSortOrder
  //   }));
  // };


  const handleViewRoute = async (id) => {
    try {
      const response = await getRouteById(id);
      const routeDetails = response.data.data;
      // console.log(response.data.data, 'responseID')
      navigate("/route-master-details", { state: { routeDetails } });
    } catch (error) {
      console.log(error);
    }
  };

  const handleShow = () => {
    setLgShow(true);
    setIsOptionsLoading(true)
    setFormInput({
      routeCode: "",
      zoneId: "",
      circleId: "",
      wardId: "",
      collectionPointId: "",
      sortOrder: "",
      shiftId: "",
      routeId: "",
      isActive: true,
    })
    setTimeout(() => {
      setIsOptionsLoading(false)
    }, 1000)
  }

  const handleZoneChange = async (zoneId) => {
    setFormInput((prevData) => ({
      ...prevData,
      zoneId: zoneId,
      circleId: "",
      wardId: "",
    }));
    setSelectedCircles("");
    setSelectedWard("");

    // Call GetAllCollectionPointsZone API with zoneId
    try {
      const response = await GetAllCollectionPointsZone({ zoneId });
      setCollectionPointZone(response.data);
      // Handle the response as needed
    } catch (error) {
      console.error("Error fetching collection points:", error);
    }

    if (zoneId) {
      try {
        const circlesData = await GetCirclebyID(zoneId);
        setCircles(circlesData);
      } catch (error) {
        console.error("Error fetching circles data:", error);
      }
    } else {
      setCircles([]);
    }
  };

  const handleCircleChange = async (circleId) => {
    setFormInput((prevData) => ({
      ...prevData,
      circleId: circleId || "",
      wardId: "", // Reset wardId when circle changes
    }));
    setSelectedWard("");

    try {
      const { zoneId } = formInput;
      const response = await GetAllCollectionPointsZoneCircle({ zoneId, circleId });
      // setCollectionPointZoneWithCircle(response.data)
      setCollectionPointZone(response.data);
      // Handle the response as needed
    } catch (error) {
      console.error("Error fetching collection points:", error);
    }


    if (circleId) {
      try {
        const wardsData = await GetWardsbyCircleId(circleId);
        // Assuming there's a function to fetch wards by circle ID
        setWards(wardsData);
      } catch (error) {
        console.error("Error fetching wards data:", error);
      }
    } else {
      // If no circle is selected, clear wards dropdown
      setWards([]);
    }
  };

  const fetchAllDataDetails = async () => {
    try {
      const zonesData = await GetZone();
      setAllZones(zonesData);
      if (selectedZone) {
        const circlesData = await GetCirclebyID(selectedZone);
        // console.log(circlesData, "circleDAAATAA")
        setCircles(circlesData);
        setSelectedCircles([]);
        setIsOptionsLoading(false)
      } else {
        setCircles([]);
        setSelectedCircles([]);
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  useEffect(
    () => {
      fetchAllDataDetails();
      fetchRoute();
    }, []);

  // const downloadAsExcel = () => {
  //   // Add serial number to each item in the collection details
  //   const dataWithSerialNumber = routeData.map((item, index) => ({
  //     ...item,
  //     's.no': index + 1,
  //   }));

  //   // Filter out only the data corresponding to the headers displayed in the table component
  //   const filteredData = dataWithSerialNumber.map(item => ({
  //     's.no': item['s.no'],
  //     routeCode: item.routeCode,
  //     zone: item.zone,
  //     circle: item.circle,
  //     ward: item.ward,
  //     shift: item.shift,
  //     status: item.status,
  //   }));

  //   const ws = XLSX.utils.json_to_sheet(filteredData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Route");
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
  //   const downloadLink = document.createElement("a");
  //   downloadLink.href = URL.createObjectURL(data);
  //   downloadLink.download = "Route.xlsx";
  //   downloadLink.click();
  // };


  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1
      }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Routes Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Routes");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
    worksheet.mergeCells(1, 2, 1, 7); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
    worksheet.getCell(1, 2).font = boldFont; // Set font style
    worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 7; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Route Details", ""]); // Update array length to match new cell range
    worksheet.mergeCells(2, 2, 2, 7); // Merge cells for Zone Details from column 2 to 4
    worksheet.getCell(2, 2).value = "Route Details"; // Ensure the value is set after merging
    worksheet.getCell(2, 2).font = boldFont; // Set font style
    worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 7; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }


    // Add empty row for spacing
    worksheet.addRow([""]);

    // worksheet.addRow(["", "", "", "", downloadDateTime, "", "", "", ""]);
    // worksheet.mergeCells(2, 5, 2, 8); // Merge cells for downloadDateTime
    // for (let col = 5; col <= 8; col++) {
    //   worksheet.getCell(2, col).font = boldFont; // Set styles individually
    //   worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    // }

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Route Code",
      "Zone",
      "Circle",
      "Ward",
      "Shift",
      "Status",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left", color: "#fff" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 11) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" }, // White text color
        };
      }
    });

    // Add data rows
    routeData.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.routeCode,
          item.zone,
          item.circle,
          item.ward,
          item.shift,
          item.status,
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 11) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "left" };
          }
        });
    });

    // Add total row with bold font

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 40 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "RouteDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  let storedPermissions = localStorage.getItem('permissionId')
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  // Use this page's own permissionId so the Add/Update buttons don't depend on
  // the shared localStorage "permissionId" (which caused them to sometimes hide).
  storedPermissions = 11;

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionId === storedPermissions);

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }


  const searchRouteHandler = (e) => {
    const term = e.target.value.toLowerCase();
    const data = filterOriginalRouteData.filter(item => item?.routeCode?.toLowerCase()?.includes(term));
    setRouteData(data);
  }

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header mb-0">
              <div className="row justify-content-between">
                <div className="col-md-3">
                  <div className="form-group">
                    <input
                      placeholder="Search Route Code"
                      type="text"
                      className="form-control bg-white"
                      onInput={searchRouteHandler}
                    />
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="flex_end_middle mb-3">
                    {canWriteValue === true ?
                      <button className="button-container" onClick={handleShow} >
                        <i className="fa-solid fa-plus me-1 icon-container"></i>
                        {t("addRoute")}
                      </button>
                      : ''}
                    <button className="btn btn-excel"
                      onClick={downloadAsExcel}>
                      <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="top-header">
                  <span >{t("route_details")}</span>
                </div>
                <TableComponent
                  DataFetchURL={routeData}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 0
                    )
                  }
                  editData={handleEditRoute}
                  editRouteData={editRouteData}
                  viewData={(id) => handleViewRoute(id)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {isOptionsLoading && <Loader />}
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {isEditMode ? "Edit Route" : "Add Route"}
          </Modal.Title>
          <i class="fa-solid fa-xmark close-container" onClick={handleClose}></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form
            onSubmit={handleSubmit(addNewRoute)}
            onKeyDown={(e) => {
              handleKeyDown(e, handleSubmit)
            }}
          >
            <div className="row">
              {/* {isEditMode ? */}
              <div className="col-md-4" style={{ display: 'none' }}>
                <div className="form-group">
                  <label className="form-label">routeId</label>
                  <input
                    type="number"
                    className="form-control"
                    name="routeId"
                    {...register('routeId')}
                    value={formInput.routeId}
                    readOnly
                    onChange={(e) => setFormInput({ ...formInput, routeId: e.target.value })}
                    disabled={!canWriteValue}
                  />
                </div>
              </div>
              {/* :
                 ''
               } */}
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Route Code <span style={{ color: '#EC1117' }}> *</span></label>
                  <input
                    type="text"
                    placeholder="Enter Route Code"
                    className={`form-control ${formInput.routeCode || !formSubmitted ? "" : "input-error"
                      }`}
                    name="routeCode"
                    {...register('routeCode')}
                    value={formInput.routeCode}
                    maxLength={8}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const sanitizedValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
                      // setFormInput({ ...formInput, routeCode: e.target.value })
                      setFormInput({ ...formInput, routeCode: sanitizedValue });
                    }}
                    disabled={!canWriteValue}
                  />
                  {!formInput.routeCode && formSubmitted && (
                    <div className="required-message">
                      Route Code is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Zone <span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    value={formInput.zoneId}
                    {...register("zoneId")}
                    name="zoneId"
                    className={`form-select ${formInput.zoneId || !formSubmitted ? "" : "input-error"
                      }`}
                    onChange={(e) => handleZoneChange(e.target.value)}
                    disabled={!canWriteValue}
                  >
                    <option value="">Select</option>
                    {allZones?.map((zone) => (
                      <option key={zone.zoneId} value={zone.zoneId}>
                        {zone.zoneName}
                      </option>
                    ))}
                  </select>
                  {!formInput.zoneId && formSubmitted && (
                    <div className="required-message">
                      Zone is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Circle <span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    value={formInput.circleId}
                    name="circleId"
                    className={`form-select ${formInput.circleId || !formSubmitted ? "" : "input-error"
                      }`}
                    {...register("circleId")}
                    onChange={(e) => {
                      setFormInput((prevData) => ({
                        ...prevData,
                        circleId: e.target.value,
                      }));
                      handleCircleChange(e.target.value);
                    }}
                    disabled={!formInput.zoneId}
                    readOnly={!canWriteValue}
                  >
                    <option value="">
                      Select
                    </option>
                    {loadingCircles && (
                      <option disabled>Loading circles...</option>
                    )}
                    {Array.isArray(circles) && circles.length > 0 ? (
                      circles.map((circle) => (
                        <option key={circle.circleId} value={circle.circleId}>
                          {circle.circleName}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>
                        No circles found
                      </option>
                    )}
                  </select>
                  {!formInput.circleId && formSubmitted && (
                    <div className="required-message">
                      Circle is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Ward<span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    value={formInput.wardId}
                    name="wardId"
                    className={`form-select ${formInput.wardId || !formSubmitted ? "" : "input-error"
                      }`}
                    {...register("wardId")}
                    onChange={(e) => {
                      setFormInput((prevData) => ({
                        ...prevData,
                        wardId: e.target.value,
                      }));
                    }}
                    disabled={!formInput.circleId}
                    readOnly={!canWriteValue}
                  >
                    <option value="">
                      Select
                    </option>
                    {loadingWards && <option disabled>Loading Wards...</option>}
                    {Array.isArray(wards) &&
                      wards.map((ward) => (
                        <option key={ward.wardId} value={ward.wardId}>
                          {ward.wardName}
                        </option>
                      ))}
                  </select>
                  {!formInput.wardId && formSubmitted && (
                    <div className="required-message">
                      Ward is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">Shift <span style={{ color: '#EC1117' }}> *</span></label>
                  <select
                    value={formInput.shiftId}
                    name="shiftId"
                    className={`form-select ${formInput.shiftId || !formSubmitted ? "" : "input-error"
                      }`}
                    {...register('shiftId')}
                    onChange={(e) => {
                      setFormInput((prevData) => ({
                        ...prevData,
                        shiftId: e.target.value,
                      }));
                      handleShiftChange(e.target.value);
                    }}
                    disabled={!canWriteValue}
                  >
                    <option value="" >Select</option>
                    {Array.isArray(shiftData) &&
                      shiftData.map((shift) => (
                        <option
                          key={shift.shiftId}
                          value={shift.shiftId}
                        >
                          {shift.shiftName}
                        </option>
                      ))}
                  </select>
                  {!formInput.shiftId && formSubmitted && (
                    <div className="required-message">
                      Shift is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
              </div>
              {/* {isEditMode ? ( */}
              <div className="col-md-4 mt-2">
                <label className="form-label">Status <span style={{ color: '#EC1117' }}> *</span></label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="activeRadio"
                      {...register('isActive')}
                      value="true"
                      checked={formInput.isActive === true}
                      // onChange={() =>
                      //   setFormInput({ ...formInput, isActive: "true" })
                      // }
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="inactiveRadio"
                      {...register('isActive')}
                      value="false"
                      checked={formInput.isActive === false}
                      // onChange={() =>
                      //   setFormInput({ ...formInput, isActive: "false" })
                      // }
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="inactiveRadio">
                      InActive
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {/* ) : (
                ""
              )} */}

            <div className="row justify-content-center bg-add-collection" >
              <div className="col-md-4 ">
                {canWriteValue === true ?
                  <button type="button" className="btn btn-excel" style={{ backgroundColor: '#fff', color: '#000', border: '1px solid #cdcdcd', borderRadius: '30px' }} onClick={addSelectOption}>
                    <i className="fa-solid fa-plus me-1 icon-container" ></i>&nbsp;  Add Collection Points
                  </button>
                  : ''}
              </div>
            </div>

            {gvpPoints.map((point) => (
              <div className="row align-items-center" key={point.id}>
                <div className="col-md-5 mb-3 mt-3">
                  <div className="form-group">
                    <label>Select Collection Point <span style={{ color: '#EC1117' }}> *</span></label>
                    <select
                      value={point.value}
                      className={`form-select ${!point.value && formSubmitted ? "input-error" : ""}`}
                      onChange={(e) => handleSelectChange(point.id, e.target.value)}
                      name="collectionPointId"
                    >
                      <option value="">--Select--</option>
                      {((formInput.zoneId && !loadingCircles) || (formInput.zoneId && formInput.circleId && !loadingWards)) && (

                        collectionPointZone.map((point) => (
                          <option
                            key={point.collectionPointId}
                            value={point.collectionPointId}
                          >
                            {point.collectionPointName}
                          </option>
                        ))

                      )}
                    </select>
                    {!point.value && formSubmitted && (
                      <div className="required-message">
                        Collection Point is Required
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-4 mb-3 mt-3">
                  <div className="form-group">
                    <label>Sort Order <span style={{ color: '#EC1117' }}> *</span></label>
                    <input
                      min={0}
                      type="number"
                      className={`form-control ${!point.sortOrder && formSubmitted ? "input-error" : ""
                        }`}
                      {...register(`sortOrder${point.id}`)}
                      name={`sortOrder${point.id}`}
                      placeholder="Enter SortOrder"
                      value={point.sortOrder}
                      onChange={(e) => handleSortOrderChange(point.id, e.target.value)}
                      disabled={!canWriteValue}
                    />
                    {!point.sortOrder && formSubmitted && (
                      <div className="required-message">
                        Sort Order is Required
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-3 mb-3 mt-4">
                  <button type="button" className="btn" style={{ backgroundColor: 'rgb(236, 17, 23)', color: "#fff", borderRadius: '30px' }} onClick={() => removeSelectOption(point.id)}>
                    Remove Point
                  </button>
                </div>
              </div>
            ))}

            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ?
                <button type="submit" className="deployment-button" >
                  <i class="fa-solid fa-check done-container"></i>
                  {isEditMode ? t("Update") : t("Save")}
                </button>
                : ''}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(RouteMaster);
